import React from "react";
import { EyeInvisibleOutlined } from "@ant-design/icons";
import { Tooltip, Tag } from "antd";
export default function VisibilityTag({ bold }) {
    return (React.createElement(Tooltip, { color: "#fff", title: "Shipment is not currently visible to transporters as an available load." },
        React.createElement(Tag, { style: { fontWeight: bold ? "bold" : "normal" } },
            React.createElement(EyeInvisibleOutlined, null),
            " Not Visible")));
}
VisibilityTag.defaultProps = {
    bold: false,
};
